import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MasterComponent } from './master/master.component';
import { MenuComponent } from './menu/menu.component';
// eslint-disable-next-line max-len
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { ServiceSelectionDialogComponent } from './service-selection-dialog/service-selection-dialog.component';
// eslint-disable-next-line max-len
import { FormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { CommonPipesModule } from '@quorum/common-pipes';
import { ShaComponentsNgUiModule } from '@quorum/sha-components-ng-ui';
import { ShaWorkOrdersNgUiModule } from '@quorum/sha-work-orders-ng-ui';
import { SvcServiceLaneNgUiModule } from '@quorum/svc-service-lane-ng-ui';
import { NgPipesModule } from 'ngx-pipes';
import { HyundaiMenuComponent } from './hyundai-menu/hyundai-menu.component';
import { MenuShellComponent } from './menu-shell/menu-shell.component';
import { NoToolbarMenuComponent } from './no-toolbar-menu/no-toolbar-menu.component';
import { QuoteMenuComponent } from './quote-menu/quote-menu.component';
import { RoHistoryDialogComponent } from './ro-history-dialog/ro-history-dialog.component';
import { SalesHintDialogComponent } from './sales-hint-dialog/sales-hint-dialog.component';
import { SelectDeclinedReasonDialogComponent } from './select-declined-reason-dialog/select-declined-reason-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule,
    NgPipesModule,
    ShaComponentsNgUiModule,
    CommonPipesModule,
    RouterModule,
    MatTreeModule,
    ShaWorkOrdersNgUiModule,
    SvcServiceLaneNgUiModule,
  ],
  declarations: [
    MasterComponent,
    MenuComponent,
    ServiceSelectionDialogComponent,
    SelectDeclinedReasonDialogComponent,
    RoHistoryDialogComponent,
    SalesHintDialogComponent,
    QuoteMenuComponent,
    NoToolbarMenuComponent,
    HyundaiMenuComponent,
    MenuShellComponent,
  ],
  exports: [MasterComponent, MenuComponent, NoToolbarMenuComponent],
})
export class XsrMaintenanceMenuNgUiModule {}
